import React from 'react';
import Nav from '../components/Nav';
import style from './About.module.css'
import Submenu from './Submenu';
import Footer from '../components/Footer';
import { useRef , useState, useEffect } from "react";
import './Recruit.css';
import { Routes, Route, Link } from 'react-router-dom';
import Support1 from './Support1';
import Support2 from './Support2';
import support from './Support.module.css'

function Support (props){


  const subMenu = [
    {
      id:1,
      link:'/support/support1',
      title:'오시는 길',
    },
    {
      id:2,
      link:'/support/support2',
      title:'문의하기',
    },
    
  ]

  const [activeList, setActiveList] = useState();

  return(
    <div className={style.aboutback}>
      <Nav />
      <div className='aboutWrap'>
        <div id={support.aboutBg}></div>
          <div className="titBox">
            <h2>고객지원</h2>
            <span>다옴솔루션은 끊임없는 변화와 혁신으로 <br /> IPT/IPCC 분야에서 최고로 인정받는 선도기업입니다.</span>
        </div>
      </div>

      <div id="lnb" className="inner lnb1">
        <div className='inner1200'>   
          <Submenu subMenu={subMenu} activeList={activeList} setActiveList={setActiveList}/>
        </div>
     </div>

     <Routes>
        <Route path="/support1" element={<Support1 />} />
        <Route path="/support2" element={<Support2 />} />
     </Routes>

  <Footer />
  </div>
  
  )
}


export default Support;